import { Paper, Typography } from "@material-ui/core";
import { translate } from "helperFunctions/translation";
import { MDBContainer } from "mdbreact";
import { stores } from "mobx-store";
import React, { useEffect, useState } from "react";
import { Doughnut } from "react-chartjs-2";

import * as styles from './styles.module.scss';

const UsersChartComponent: React.FC = () => {
    const {
        statisticsStore,
    } = stores;
    const [usersData, setUserData] = useState({
        labels: [
          translate('PORTAL_USERS'),
          translate('MOBILE_USERS'),
          translate('SPORTS_USERS'),
          translate('UNKNOWN_USERS'),
        ],
        datasets: [
          {
            data: [0, 0, 0, 0],
            backgroundColor: [
              styles.chartFirstColor,
              styles.chartSecondColor,
              styles.chartThirdColor,
              styles.chartFourthColor,
            ],
            hoverBackgroundColor: [
              styles.chartFirstColorHover,
              styles.chartSecondColorHover,
              styles.chartThirdColorHover,
              styles.chartFourthColorHover,
            ],
          },
        ],
      });

    useEffect(() => { initUsersChart() }, []);
    const initUsersChart = async () => {
        await statisticsStore!.getUsersStatistics();
        const data = [
          statisticsStore!.usersStatistics.registeredFromPortal,
          statisticsStore!.usersStatistics.registeredFromMobile,
          statisticsStore!.usersStatistics.registeredFromSportsReservation,
          statisticsStore!.usersStatistics.registeredFromUnknown,
        ];
        setUserData({
            labels: [
              translate('PORTAL_USERS', {}),
              translate('MOBILE_USERS', {}), 
              translate('SPORTS_USERS', {}), 
              translate('UNKNOWN_USERS', {}),
            ],
            datasets: [
              {
                data,
                backgroundColor: [
                  styles.chartFirstColor,
                  styles.chartSecondColor,
                  styles.chartThirdColor,
                  styles.chartFourthColor,
                ],
                hoverBackgroundColor: [
                  styles.chartFirstColorHover,
                  styles.chartSecondColorHover,
                  styles.chartThirdColorHover,
                  styles.chartFourthColorHover,
                ],
              },
            ],
        });
    };
    return (
        <div className={styles.chartsContainer}>
        <div className={styles.doughnutContainer}>
          <MDBContainer>
            <h3 className="mt-5">
              {translate('STATISTICS_USERS', {
              })}
            </h3>
            <Doughnut
              data={usersData}
              options={{
                responsive: true,
              }}
            />
          </MDBContainer>
        </div>
        <div>
          <Paper className={styles.cardsContainer}>
            <Typography variant="h5" component="h3">
              {translate('TOTAL_USERS', {
              })}
            </Typography>
            <Typography component="p">
              {statisticsStore!.usersStatistics.totalRegisteredUsers}
              {' '} users
            </Typography>
          </Paper>
          <Paper className={styles.cardsContainer}>
            <Typography variant="h5" component="h3">
              {translate('USERS_FROM_PORTAL', {
              })}
            </Typography>
            <Typography component="p">
              {statisticsStore!.usersStatistics.registeredFromPortal
                ? statisticsStore!.usersStatistics.registeredFromPortal : 0}
              {' '} users
            </Typography>
          </Paper>
          <Paper className={styles.cardsContainer}>
            <Typography variant="h5" component="h3">
              {translate('USERS_FROM_MOBILE', {
              })}
            </Typography>
            <Typography component="p">
              {statisticsStore!.usersStatistics.registeredFromMobile
                ? statisticsStore!.usersStatistics.registeredFromMobile : 0}
              {' '} users
            </Typography>
          </Paper>
          <Paper className={styles.cardsContainer}>
            <Typography variant="h5" component="h3">
              {translate('USERS_FROM_SPORTS', {
              })}
            </Typography>
            <Typography component="p">
              {statisticsStore!.usersStatistics.registeredFromSportsReservation
                ? statisticsStore!.usersStatistics.registeredFromSportsReservation : 0}
              {' '} users
            </Typography>
          </Paper>
          <Paper className={styles.cardsContainer}>
            <Typography variant="h5" component="h3">
              {translate('USERS_FROM_UNKNOWN', {
              })}
            </Typography>
            <Typography component="p">
              {statisticsStore!.usersStatistics.registeredFromUnknown
                ? statisticsStore!.usersStatistics.registeredFromUnknown : 0}
              {' '} users
            </Typography>
          </Paper>
        </div>
      </div>
    );
};

export default UsersChartComponent;